export default "__VITE_ASSET__BS6Rix4___"